module.exports = "mutation startTRB{startTRB{id adviceId status partner{id name}}}"